import React, { FunctionComponent, useEffect, useState } from 'react';
import withStyles from 'react-jss';
import { Redirect, withRouter, match } from 'react-router-dom';
import { compose } from 'recompose';
import { Container, Grid } from 'semantic-ui-react';

import { ClassProp } from 'helpers/types';
import { Theme } from 'config';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
  match: match;
};

const styles = (theme: Theme) => ({
  grid: {
    position: 'relative',
    margin: '0 !important',
    width: '100% !important',
    height: '100% !important',
  },
  container: {
    display: 'flex',
    marginTop: '8rem',
    color: `${theme.darkGray} !important`,
  },
  successMessage: {
    display: 'block',
    color: `${theme.violet} !important`,
    fontWeight: 100,
  },
  successText: {
    lineHeight: '1.5rem',
    color: `${theme.darkGray} !important`,
  },
  successImage: {
    width: '100%',
    display: 'flex !important',
    justifyContent: 'center !important',
  },
});

const PostOnboarding: FunctionComponent<Props> = ({ classes, match }) => {
  const [redirect, setRedirect] = useState<boolean>(false);
  const { merchantName }: any = match.params;

  useEffect(() => {
    const timer = setTimeout(() => {
      setRedirect(true);
    }, 7500);
    return () => clearTimeout(timer);
  }, []);

  if (redirect) {
    return <Redirect to={`/${merchantName}/overview`} push />;
  }

  return (
    <Grid className={classes.grid}>
      <Container className={classes.container}>
        <h2 className={classes.successMessage}>You are all set!</h2>
        <p className={classes.successText}>
          Your account is being reviewed by our Success Team and your offer will
          be live soon.
        </p>
        <p className={classes.successText}>
          As soon as purchase data starts flowing, this is where you’ll come to
          review campaign performance.
        </p>
        <div className={classes.successImage}>
          <img
            src="https://doshdev-assets.s3.amazonaws.com/icons/Group.svg"
            alt=""
          />
        </div>
      </Container>
    </Grid>
  );
};

export default compose<Props, any>(
  withRouter,
  withStyles(styles),
)(PostOnboarding);
